import { render, staticRenderFns } from "./CarrierImport.vue?vue&type=template&id=6f327bdc&scoped=true"
import script from "./CarrierImport.vue?vue&type=script&lang=js"
export * from "./CarrierImport.vue?vue&type=script&lang=js"
import style0 from "./CarrierImport.vue?vue&type=style&index=0&id=6f327bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f327bdc",
  null
  
)

export default component.exports